import DynamicPage from './[slug]';
export default DynamicPage;
